import { Box } from '@mui/material';

export default function CasColorSwatch({ value }: { value?: string | null }) {
  if (!value) return null;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: '3px',
        border: '1px solid rgba(0, 0, 0, 0.2)',
        backgroundColor: value,
        flexShrink: 0,
      }}
    />
  );
}
